// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Urbanist", sans-serif !important;
}

/* 
scss
 */
/* 
Body Theme Color
 */
/* 
Dark Theme Colors
*/
/* 
Button Theme
*/
/* 
Max Dashboard scss
*/
/* 
Min Dashboard scss
*/
/* 
Max Dashboard scss
*/
.profilepage_dashboard__f7faf {
  width: calc(100% - 320px);
  position: relative;
  left: 290px;
  padding: 30px;
  border-radius: 8px;
  min-height: auto !important;
  background-color: #F5F6FA;
  height: calc(100vh - 160px);
  overflow-y: auto;
}

.profilepage_dashboardContain__hkddW {
  width: calc(100% - 320px);
  background-Color: #F5F6FA;
  border-radius: 8px;
}

.profilepage_bodythemedark__U3bK3 .profilepage_dashboardContain__hkddW,
.profilepage_bodythemedark__U3bK3 .profilepage_dashboard__f7faf,
.profilepage_bodythemedark__U3bK3 .profilepage_cont2__vX6Z8 {
  background-Color: #0f1824;
}

.profilepage_top_header__ghfWd .profilepage_top_header_inner__tctlf {
  background-color: transparent;
  height: auto;
  overflow-y: unset;
}

/* 
Min Dashboard scss
*/
.profilepage_cont2__vX6Z8 {
  width: calc(100% - 50px);
  left: 50px;
  position: relative;
  padding: 30px;
  border-radius: 8px;
  background: #F5F6FA;
  height: calc(100vh - 160px);
  min-height: auto !important;
  overflow-y: auto;
  /* 
  background-Color: \$dashboardbackgroundColor;
    padding-bottom: 8%;
  */
}

.profilepage_subLink__a0P7- svg {
  position: relative;
  top: -2px;
  left: -7px;
}

.profilepage_footer__35p4i {
  height: 70px;
}

body {
  background-color: #fff;
}

/* 
THEME CHANGE
*/
.profilepage_bodythemelight__yGXd9 {
  background-color: #fff;
  padding-top: 90px;
}

.profilepage_bodythemedark__U3bK3 {
  background-color: #132337;
  padding-top: 90px;
}

/* 
Header Navbar Theme
*/
.profilepage_headerthemelight__HG24f {
  background-color: #fff;
}

.profilepage_headerthemedark__6lim7 {
  background-color: #132337;
}

.profilepage_top_header__ghfWd {
  min-height: 90px;
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  z-index: 1;
  top: 0;
}

/* 
LEFT MENU THEME CHANGE
*/
.profilepage_menuthemelight__RZgav {
  background-color: #fff;
}

.profilepage_menuthemedark__Wr\\+AP {
  background-color: #132337;
}

/* 
LEFT MENU LINKS THEME CHANGE
*/
.profilepage_menulinklight__ZWenu span {
  color: #666666 !important;
}

.profilepage_menulinklight__ZWenu a {
  color: #CBCBCB !important;
}

.profilepage_menulinklight__ZWenu:hover span, .profilepage_menulinklight__ZWenu:hover a {
  color: #fff !important;
}

.profilepage_menulinkdarkSelected__ns9y7 {
  background-color: #1c2e45;
  color: #3b82f6;
}

.profilepage_menuthemelight__RZgav .profilepage_menulinklightSelected__bHyyK {
  /*background-color: \$lightthemecolor;*/
  color: #fff !important;
  background-color: #131F43;
}

.profilepage_menulinkdark__33m\\+h {
  color: #92afd3 !important;
}

.profilepage_menulinklight__ZWenu:hover {
  color: #fff !important;
  background-color: #131F43;
}

.profilepage_menulinklight__ZWenu .profilepage_sub_arrow__5Zuyi svg path {
  stroke: #CBCBCB !important;
}

.profilepage_menulinklight__ZWenu:hover .profilepage_sub_arrow__5Zuyi svg path {
  stroke: #fff !important;
}

.profilepage_menulinkdark__33m\\+h .profilepage_sub_arrow__5Zuyi svg path {
  stroke: #92afd3 !important;
}

.profilepage_menulinkdark__33m\\+h:hover .profilepage_sub_arrow__5Zuyi svg path {
  stroke: #fff !important;
}

.profilepage_menulinkdark__33m\\+h:hover {
  background-color: #1c2e45;
  color: #fff;
}

/* 
BODY HEADERS
*/
.profilepage_headinglight__\\+d\\+Kj {
  color: #60677e;
}

.profilepage_headingdark__U9OsA {
  color: #60677e;
}

/* 
SEARCH BOX THEME COLOR
*/
.profilepage_searchboxlight__\\+vXmM {
  background-color: #fff;
  border: none;
}

.profilepage_searchboxdark__PlzjR {
  background-color: #132337;
  color: #fff;
  border: none;
}

.profilepage_searchboxdark__PlzjR::placeholder {
  color: #60677e;
}

/* 
CUSTOM TABLE THEME COLOR
*/
.profilepage_tableheadlight__N\\+1m0 {
  background-color: #131F43;
  border-radius: 5px 5px 0px 0px;
}

.profilepage_tableheadlight__N\\+1m0 th {
  color: #fff;
}

thead .profilepage_tableheadlight__N\\+1m0 th:first-child,
thead .profilepage_tableheaddark__pzdGJ th:first-child {
  border-radius: 5px 0 0 0px;
}

thead .profilepage_tableheadlight__N\\+1m0 th:last-child,
thead .profilepage_tableheaddark__pzdGJ th:last-child {
  border-radius: 0 5px 0px 0;
}

th:first-child {
  border-radius: 0px;
}

td:last-child {
  border-radius: 0px;
}

table.profilepage_table__PkPOM.profilepage_table-borderless__3OWpu {
  border-collapse: separate !important;
  border-spacing: 0 0px !important;
}

.profilepage_tableheaddark__pzdGJ {
  background-color: #132337;
  color: #fff;
}

.profilepage_table-borderless__3OWpu tr:nth-child(even) {
  background-color: #F9FAFB;
}

.profilepage_table-borderless__3OWpu .profilepage_left-section__yST00 {
  padding-top: 10px;
}

.profilepage_tablebodylight__G8aH6 td,
.profilepage_tablebodydark__aL83x td {
  padding: 0.5rem 1rem !important;
  line-height: 45px;
}

.profilepage_tablebodylight__G8aH6 {
  background-color: #fff;
}
.profilepage_tablebodylight__G8aH6:hover {
  background-color: #ddecf9;
  cursor: auto;
}

.profilepage_tablebodydark__aL83x {
  /* background-color: \$primarydark-color; */
  color: #60677e;
}
.profilepage_tablebodydark__aL83x:hover {
  background-color: rgba(33, 150, 243, 0.1);
  cursor: auto;
}

/* 
PAGINATION THEME COLOR
*/
.profilepage_paginationlight__JC8Io {
  color: #60677e !important;
  font-size: 13px !important;
}

.profilepage_paginationdark__47-Us {
  color: #60677e !important;
  font-size: 13px !important;
}

/* 
SETTING FORM THEME COLOR
*/
.profilepage_formthemelight__x\\+moB {
  background-color: #fff;
  color: #1d1d1d !important;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.08);
}

.profilepage_formthemedark__cHqTr {
  background-color: #132337;
  color: #60677e !important;
  font-size: 14px;
}
.profilepage_formthemedark__cHqTr ::placeholder {
  color: #60677e;
}

/* 
VIEW FORM DETAILS BOX THEME COLOR
*/
.profilepage_viewformlight__k\\+6pb {
  background-color: #f3f6f9;
}

.profilepage_permissionboxlight__LHtZE {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

.profilepage_permissionboxdark__B-n-5 {
  background-color: #0f1824;
  border: solid 1px #242434;
}

.profilepage_errormsgclr__KHi1K {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}

/* 
Graph theme
*/
.profilepage_graphclrlight__afP5N {
  background-color: #fff;
}

.profilepage_graphclrdark__q0mUw {
  background-color: #132337;
}

/* 
Counter theme
*/
#profilepage_card1bglight__TdFoy {
  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */
  background-color: #fff;
}

#profilepage_card1bgdark__LnXNf {
  background: #392f28;
}

#profilepage_card2bglight__fuVfR {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #fff;
}

#profilepage_card2bgdark__aYkis {
  background: #1c3238;
}

#profilepage_card3bglight__Aaxrz {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #fff;
}

#profilepage_card3bgdark__Jk5Oj {
  background: #3a2434;
}

#profilepage_card4bglight__Kgj-s {
  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */
  background-color: #fff;
}

#profilepage_card4bgdark__d9yP4 {
  background: #2f264f;
}

#profilepage_card1bgdark__LnXNf a, #profilepage_card1bgdark__LnXNf p,
#profilepage_card2bgdark__aYkis a, #profilepage_card2bgdark__aYkis p,
#profilepage_card3bgdark__Jk5Oj a, #profilepage_card3bgdark__Jk5Oj p,
#profilepage_card4bgdark__d9yP4 a, #profilepage_card4bgdark__d9yP4 p {
  color: #fff;
}

/* 
Action button theme
*/
.profilepage_actionbtnlight__oe7Kr {
  color: rgba(70, 71, 91, 0.8705882353);
}

.profilepage_actionbtnlight__oe7Kr:hover {
  cursor: pointer;
}

.profilepage_actionbtndark__D07fP {
  color: #60677e;
}

/* 
profile dropdowntheme
*/
.profilepage_profiledropdownlight__\\+l7Jy {
  background-color: #fff;
}

.profilepage_profiledropdowndark__2Nv11 {
  background-color: #151521;
}

.profilepage_settingsection__GDOL5 #profilepage_addform__DRU9M.profilepage_formthemedark__cHqTr .profilepage_savebtn__pa-Rp {
  background-color: #3b82f6;
  color: #fff;
}

#profilepage_addform__DRU9M.profilepage_formthemedark__cHqTr .profilepage_savebtn__pa-Rp {
  background-color: #3b82f6;
  color: #fff;
}

.profilepage_profile_conatiner__n\\+Sap {
  border-radius: 5px !important;
}

.profilepage_bodythemedark__U3bK3 .profilepage_ag-theme-alpine__t\\+UOw .profilepage_ag-row__qd5R6 {
  background: #000 !important;
}

.profilepage_bodythemedark__U3bK3 .profilepage_formbtn__JcqVp {
  background-color: #3b82f6;
}

.profilepage_bodythemedark__U3bK3 .profilepage_formbtn__JcqVp:hover {
  background-color: #2563eb;
}

.profilepage_bodythemedark__U3bK3 .profilepage_resetbtn__Qq1fD {
  color: #fff;
  background-color: transparent;
  border: solid 1px #3b82f6;
}

.profilepage_bodythemedark__U3bK3 .profilepage_resetbtn__Qq1fD:hover {
  background-color: #3b82f6;
}

.profilepage_headingdark__U9OsA span {
  background-color: #132337;
}

.profilepage_resetbtn__Qq1fD {
  font-size: 16px;
  font-weight: 600;
  border-radius: 5px;
  background-color: transparent;
  border: solid 1px #131F43;
  color: #131F43;
  min-width: 113px;
}

.profilepage_resetbtn__Qq1fD:hover,
.profilepage_resetbtn__Qq1fD:active,
.profilepage_resetbtn__Qq1fD:focus {
  background-color: #131F43;
  color: #fff;
}

.profilepage_addBtn__lX2tJ {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.profilepage_addbtnlight__6xH2o {
  background-color: #38A169;
}

.profilepage_addbtndark__KT3sY {
  background-color: #3b82f6;
}

.profilepage_addbtndark__KT3sY:hover {
  background-color: #2563eb;
}

.profilepage_formthemedark__cHqTr label {
  color: #92afd3;
}

.profilepage_addBtn__lX2tJ svg {
  margin-right: 10px;
  position: relative;
  top: 2px;
}

.profilepage_addBtn__lX2tJ:hover {
  color: #fff;
  background-color: #38A169;
  border: none;
}

.profilepage_cust_addBtn__kVlDz.profilepage_addBtn__lX2tJ svg {
  top: 2px;
}

.profilepage_deleteBtn__hnEUw {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.profilepage_deleteBtn__hnEUw {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.profilepage_deleteBtn__hnEUw:active, .profilepage_deleteBtn__hnEUw:focus {
  background-color: #F94747 !important;
  color: #fff !important;
  box-shadow: none !important;
}

.profilepage_deleteBtn__hnEUw svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.profilepage_deleteBtn__hnEUw:hover,
.profilepage_deleteBtn__hnEUw:active,
.profilepage_deleteBtn__hnEUw:focus {
  background-color: #F94747;
  color: #fff;
  border: none;
}

.profilepage_confirmBtn__HkdQl {
  background-color: #131F43;
}

.profilepage_confirmBtn__HkdQl:hover,
.profilepage_confirmBtn__HkdQl:active,
.profilepage_confirmBtn__HkdQl:focus {
  background-color: #131F43;
}

.profilepage_confirmBtn__HkdQl svg {
  top: 0;
}

.profilepage_delPopContainer__4yMmw .profilepage_modal-body__nGjkw {
  padding: 25px;
  text-align: center;
}

.profilepage_delPopContainer__4yMmw .profilepage_delet_icon__UqIhu {
  margin-bottom: 11px;
}

.profilepage_delPopContainer__4yMmw p {
  color: #131f43;
  font-size: 14px;
  font-weight: 700;
}

.profilepage_arrowback__70GXL svg {
  fill: #000;
}

.profilepage_bodythemedark__U3bK3 .profilepage_arrowback__70GXL {
  background-color: rgba(59, 130, 246, 0.2);
  color: #3b82f6;
}

.profilepage_bodythemedark__U3bK3 .profilepage_arrowback__70GXL svg {
  fill: #3b82f6;
}

.profilepage_bodythemedark__U3bK3 .profilepage_drpdwn_btn__o1f9m {
  background-color: #132337;
}

.profilepage_bodythemedark__U3bK3 .profilepage_empname__qjhb9 {
  color: #92afd3 !important;
}

.profilepage_bodythemedark__U3bK3 .profilepage_navitemli__SMmg1 a {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.profilepage_bodythemedark__U3bK3 .profilepage_tabnavli__3ewNE a.profilepage_settingsgeneral__rW4Tl,
.profilepage_bodythemedark__U3bK3 .profilepage_tabnavli__3ewNE a.profilepage_settingslinks__MsUdd:hover {
  background-color: #3b82f6;
  color: #fff;
}

.profilepage_bodythemedark__U3bK3 .profilepage_tabnavli__3ewNE a.profilepage_settingslinks__MsUdd {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.profilepage_headerthemedark__6lim7 .profilepage_dropdown_menu_contain__iir6- {
  background-color: #1c2e45;
  color: #fff;
}

.profilepage_headerthemedark__6lim7 .profilepage_dropdown_menu_contain__iir6- ul li a,
.profilepage_headerthemedark__6lim7 .profilepage_dropdown_menu_contain__iir6- .profilepage_dropdown_item__CrmAQ,
.profilepage_headerthemedark__6lim7 .profilepage_dropdown_menu_contain__iir6- .profilepage_dropdown_item__CrmAQ h5 {
  color: #fff;
}

.profilepage_headerthemedark__6lim7 .profilepage_dropdown_menu_contain__iir6- ul li a:hover,
.profilepage_headerthemedark__6lim7 .profilepage_dropdown_menu_contain__iir6- .profilepage_dropdown_item__CrmAQ:hover {
  background-color: #132337;
  color: #fff;
}

.profilepage_dropdown_item__CrmAQ:active {
  background-color: #F5F6FA;
}

.profilepage_profile_arrrow_dwn__r\\+RYo {
  stroke: #132337;
}

.profilepage_headerthemedark__6lim7 .profilepage_profile_arrrow_dwn__r\\+RYo {
  stroke: #fff;
}

.profilepage_dateinputbox1__kTTaR input,
.profilepage_dateinputbox1__kTTaR span {
  color: #fff !important;
}

/* LOGOUT MODAL */
@media only screen and (max-width: 1200px) {
  .profilepage_tableheadlight__N\\+1m0 th {
    min-width: 100px;
  }
}
@media only screen and (max-width: 1024px) {
  .profilepage_dashboard__f7faf {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    padding: 10px 10px !important;
  }
  .profilepage_cont2__vX6Z8 {
    height: calc(100vh - 160px);
    overflow-y: auto;
  }
}
@media only screen and (max-width: 998px) {
  /* #dashboardcont2{
     height: auto !important;
   }*/
}
@media only screen and (max-width: 767px) {
  .profilepage_sectionright__\\+Mbgv {
    float: unset !important;
  }
  .profilepage_dashboard__f7faf {
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 600px) {
  .profilepage_cont2__vX6Z8 {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    position: relative !important;
    padding: 10px !important;
  }
  .profilepage_bodythemelight__yGXd9, .profilepage_bodythemedark__U3bK3 {
    padding-top: 110px;
  }
}
@media (min-width: 576px) {
  .profilepage_exer_modal_contain__oT7Kn .profilepage_modal-dialog__9G6zp {
    max-width: 1055px;
  }
  .profilepage_delPopContainer__4yMmw .profilepage_modal-dialog__9G6zp {
    max-width: 350px;
  }
}
.profilepage_settingsection__GDOL5 {
  margin-bottom: 50px;
  padding-bottom: 30px;
}
.profilepage_settingsection__GDOL5 #profilepage_settingsheading__eY9X1 {
  font-size: 18px;
}
.profilepage_settingsection__GDOL5 .profilepage_settingslinks__MsUdd {
  text-decoration: none;
  letter-spacing: 0.15em;
  display: inline-block;
  position: relative;
}
.profilepage_settingsection__GDOL5 .profilepage_settingsgeneral__rW4Tl {
  text-decoration: none;
  letter-spacing: 0.15em;
  display: inline-block;
  position: relative;
  color: #fff;
  background-color: #131F43;
}
.profilepage_settingsection__GDOL5 .profilepage_settingslinks__MsUdd:hover {
  color: #fff;
  background-color: #131F43;
}
.profilepage_settingsection__GDOL5 .profilepage_settingsgeneral__rW4Tl:hover {
  color: #fff;
  background-color: #131F43;
}
.profilepage_settingsection__GDOL5 #profilepage_layoutnav__wq9JM {
  border-radius: 5px;
}

#profilepage_addform__DRU9M {
  width: 100%;
  border-radius: 5px;
  margin-top: 30px;
  padding-bottom: 30px;
}
#profilepage_addform__DRU9M #profilepage_addheading__-dxn3 {
  font-size: 18px;
  margin-left: 10px;
}
#profilepage_addform__DRU9M .profilepage_profilepicdiv__pd\\+Tp {
  border-radius: 5px;
}
#profilepage_addform__DRU9M .profilepage_profilepic__LNywb {
  width: 100%;
  height: auto;
  border-radius: 5px;
}
#profilepage_addform__DRU9M .profilepage_penicon__lFo6n {
  margin-right: 5px;
}
#profilepage_addform__DRU9M .profilepage_namesection__iSS9i {
  display: inline-block;
  margin-left: 20px;
}
#profilepage_addform__DRU9M .profilepage_profilename__elZhR {
  font-size: 16px;
  margin-top: 30px;
}
#profilepage_addform__DRU9M .profilepage_profileedit__GF2gr {
  font-size: 14px;
  text-decoration: none;
  color: #fff;
  background-color: #131F43;
  padding: 10px;
  border-radius: 4px;
}
#profilepage_addform__DRU9M .profilepage_editbtntop__vydyF {
  float: right;
}
#profilepage_addform__DRU9M #profilepage_empdiv__Q3gCu {
  padding: 0px 0px 0px 15px;
  margin-bottom: 10px;
  border-radius: 5px;
}
#profilepage_addform__DRU9M #profilepage_empdiv__Q3gCu .profilepage_title__edgfj {
  font-size: 13px;
  font-weight: 600;
  color: #727272;
  margin-bottom: 7px;
  display: block;
}
#profilepage_addform__DRU9M #profilepage_empdiv__Q3gCu.profilepage_viewformlight__k\\+6pb .profilepage_empname__qjhb9 {
  color: #131F43;
}
#profilepage_addform__DRU9M #profilepage_empdiv__Q3gCu .profilepage_empname__qjhb9 {
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  padding-bottom: 0px;
  word-break: break-word;
}

.profilepage_viewformlight__k\\+6pb {
  background-color: transparent;
}

.profilepage_bodythemedark__U3bK3 #profilepage_addform__DRU9M.profilepage_formthemedark__cHqTr .profilepage_profileedit__GF2gr {
  background-color: #3b82f6;
  color: #fff;
}

.profilepage_bodythemelight__yGXd9 #profilepage_addform__DRU9M.profilepage_formthemelight__x\\+moB .profilepage_profileedit__GF2gr {
  background-color: #131F43;
  color: #fff;
}

.profilepage_formthemedark__cHqTr #profilepage_empdiv__Q3gCu .profilepage_title__edgfj {
  color: #fff !important;
}

@media only screen and (max-width: 992px) {
  .profilepage_editbtntop__vydyF {
    float: left !important;
  }
}
@media only screen and (max-width: 878px) {
  #profilepage_layoutnav__wq9JM {
    display: flex !important;
  }
  .profilepage_settingslinks__MsUdd {
    margin-right: 8px !important;
    font-size: 14px !important;
  }
  .profilepage_settingsgeneral__rW4Tl {
    margin-right: 8px !important;
    font-size: 14px !important;
  }
  #profilepage_addform__DRU9M .profilepage_profilepic__LNywb {
    margin-bottom: 30px;
  }
}
@media only screen and (max-width: 510px) {
  .profilepage_settingslinks__MsUdd {
    margin-right: 6px !important;
    font-size: 13px !important;
  }
  .profilepage_settingsgeneral__rW4Tl {
    margin-right: 6px !important;
    font-size: 13px !important;
  }
}
@media only screen and (max-width: 495px) {
  .profilepage_settingslinks__MsUdd {
    margin-right: 5px !important;
    font-size: 12px !important;
  }
  .profilepage_settingsgeneral__rW4Tl {
    margin-right: 5px !important;
    font-size: 12px !important;
  }
}
@media only screen and (max-width: 331px) {
  .profilepage_settingsgeneral__rW4Tl, .profilepage_settingslinks__MsUdd {
    padding: 12px !important;
  }
  .profilepage_namesection__iSS9i {
    margin-left: 5px !important;
  }
}
@media only screen and (max-width: 600px) {
  #profilepage_dashboardcont2__-ZZ-P {
    width: calc(100% - 50px);
    left: 50px;
    position: relative;
    padding: 30px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Variables/Variables.scss","webpack://./src/pages/profile/profilepage.module.scss"],"names":[],"mappings":"AAEA;EACE,8CAAA;ACAF;;ADGA;;EAAA;AAmDA;;EAAA;AAWA;;CAAA;AAKA;;CAAA;AASA;;CAAA;AAQA;;CAAA;AAMA;;CAAA;AAIA;EACE,yBAhBe;EAiBf,kBAAA;EACA,WAhBc;EAiBd,aAhBiB;EAiBjB,kBAAA;EACA,2BAAA;EACA,yBA3FO;EA4FP,2BAAA;EACA,gBAAA;ACzEF;;AD2EA;EACE,yBAAA;EACA,yBAjGO;EAkGP,kBAAA;ACxEF;;AD0EA;;;EAGE,yBAlEoB;ACLtB;;ADyEA;EACE,6BAAA;EACA,YAAA;EACA,iBAAA;ACtEF;;ADyEA;;CAAA;AAIA;EACE,wBAvCU;EAwCV,UAvCS;EAwCT,kBAAA;EACA,aA/CiB;EAgDjB,kBAAA;EACA,mBAzHO;EA0HP,2BAAA;EACA,2BAAA;EACA,gBAAA;EACA;;;GAAA;ACpEF;;AD0EA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;ACvEF;;AD4EA;EACE,YAAA;ACzEF;;AD4EA;EACE,sBAjGY;ACwBd;;AD4EA;;CAAA;AAGA;EACE,sBAxGY;EAyGZ,iBAAA;ACzEF;;AD2EA;EACE,yBAvHgB;EAwHhB,iBAAA;ACxEF;;AD2EA;;CAAA;AAGA;EACE,sBApHY;AC4Cd;;AD2EA;EACE,yBAnIgB;AC2DlB;;AD0EA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,MAAA;ACvEF;;AD0EA;;CAAA;AAGA;EACE,sBAxIY;ACiEd;;ADyEA;EACE,yBAtJgB;ACgFlB;;ADyEA;;CAAA;AAGA;EACE,yBAAA;ACtEF;;ADyEA;EACE,yBAAA;ACtEF;;ADyEA;EACE,sBAAA;ACtEF;;ADyEA;EACE,yBAvKsB;EAwKtB,cAlLkB;AC4GpB;;ADwEA;EACE,sCAAA;EACA,sBAAA;EACA,yBAlNc;AC6IhB;;ADwEA;EACE,yBAAA;ACrEF;;ADwEA;EACE,sBAAA;EACA,yBA3Nc;ACsJhB;;ADwEA;EACE,0BAAA;ACrEF;;ADwEA;EACE,uBAAA;ACrEF;;ADwEA;EACE,0BAAA;ACrEF;;ADwEA;EACE,uBAAA;ACrEF;;ADwEA;EACE,yBA1MsB;EA2MtB,WAlMY;AC6Hd;;ADwEA;;CAAA;AAGA;EACE,cAtMe;ACiIjB;;ADwEA;EACE,cA1Me;ACqIjB;;ADwEA;;CAAA;AAGA;EACE,sBApNY;EAqNZ,YAAA;ACrEF;;ADwEA;EACE,yBApOgB;EAqOhB,WA1NY;EA2NZ,YAAA;ACrEF;;ADuEA;EACE,cA3Ne;ACuJjB;;ADuEA;;CAAA;AAGA;EACE,yBAnRc;EAoRd,8BAAA;ACpEF;;ADsEA;EACE,WAzOY;ACsKd;;ADqEA;;EAEE,0BAAA;AClEF;;ADoEA;;EAEE,0BAAA;ACjEF;;ADmEA;EACE,kBAAA;AChEF;;ADkEA;EACE,kBAAA;AC/DF;;ADiEA;EACE,oCAAA;EACA,gCAAA;AC9DF;;ADiEA;EACE,yBAvPkB;EAwPlB,WAhQY;ACkMd;;ADgEA;EACE,yBAAA;AC7DF;;AD+DA;EACE,iBAAA;AC5DF;;AD8DA;;EAEE,+BAAA;EACA,iBAAA;AC3DF;;AD6DA;EACE,sBA9QY;ACoNd;AD4DE;EACE,yBAAA;EACA,YAAA;AC1DJ;;AD6DA;EACC,0CAAA;EACC,cApRe;AC0NjB;AD4DE;EACE,yCAAA;EACA,YAAA;AC1DJ;;AD8DA;;CAAA;AAGA;EACE,yBAAA;EACA,0BAAA;AC3DF;;AD6DA;EACE,yBAAA;EACA,0BAAA;AC1DF;;AD6DA;;CAAA;AAGA;EACE,sBA/SY;EAgTZ,yBAAA;EACA,qDAAA;AC1DF;;AD4DA;EACE,yBA5SkB;EA6SlB,yBAAA;EACA,eAAA;ACzDF;AD2DE;EACE,cAtTa;AC6PjB;;AD8DA;;CAAA;AAGA;EACE,yBArUgB;AC0QlB;;AD8DA;EACE,yBAAA;EACA,yBAAA;AC3DF;;AD6DA;EACE,yBApVoB;EAqVpB,yBAAA;AC1DF;;AD6DA;EACE,UAAA;EACA,eAAA;EACA,eAAA;AC1DF;;AD6DA;;CAAA;AAGA;EACE,sBAxVY;AC8Rd;;AD6DA;EACE,yBApVkB;AC0RpB;;AD8DA;;CAAA;AAGA;EACE,iGAAA;EACA,sBArWY;AC0Sd;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;EACE,gGAAA;EACA,sBA9WY;ACmTd;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;EACE,gGAAA;EACA,sBAvXY;AC4Td;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;EACE,gGAAA;EACA,sBAhYY;ACqUd;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;;;;EAIE,WA3YY;ACgVd;;AD8DA;;CAAA;AAGA;EACE,qCAAA;AC3DF;;AD6DA;EACE,eAAA;AC1DF;;AD4DA;EACE,cArZe;AC4VjB;;AD6DA;;CAAA;AAGA;EACE,sBAAA;AC1DF;;AD6DA;EACE,yBAAA;AC1DF;;AD6DA;EACE,yBAzbkB;EA0blB,WAzaY;AC+Wd;;AD4DA;EACE,yBA7bkB;EA8blB,WA7aY;ACoXd;;AD4DA;EACE,6BAAA;ACzDF;;AD4DA;EACE,2BAAA;ACzDF;;AD4DA;EACE,yBA1ckB;ACiZpB;;AD4DA;EACE,yBA7cwB;ACoZ1B;;AD4DA;EACE,WAjcY;EAkcZ,6BAAA;EACA,yBAAA;ACzDF;;AD4DA;EACE,yBAxdkB;AC+ZpB;;AD6DA;EACE,yBAvdgB;AC6ZlB;;AD6DA;EACE,eAAA;EACA,gBArgBc;EAsgBd,kBAAA;EACA,6BAAA;EACA,yBAAA;EACA,cAngBc;EAogBd,gBAAA;AC1DF;;AD4DA;;;EAGE,yBAzgBc;EA0gBd,WA5dY;ACmad;;AD4DA;EACE,gBAAA;EACA,YAAA;EACA,WAleY;EAmeZ,yBA9fY;EA+fZ,YAAA;EACA,eAAA;EACA,gBA1hBc;ACiehB;;AD4DA;EACE,yBArgBY;AC4cd;;AD2DA;EACE,yBA9fkB;ACscpB;;AD0DA;EACE,yBAhgBwB;ACyc1B;;AD0DA;EACE,cAtgBiB;AC+cnB;;AD2DA;EACE,kBAAA;EACA,kBAAA;EACA,QAAA;ACxDF;;AD2DA;EACE,WA/fY;EAggBZ,yBA3hBY;EA4hBZ,YAAA;ACxDF;;AD2DA;EACE,QAAA;ACxDF;;AD2DA;EACE,gBAAA;EACA,YAAA;EACA,yBA/hBW;EAgiBX,WA5gBY;EA6gBZ,eAAA;EACA,gBAlkBc;EAmkBd,YAAA;ACxDF;;AD2DA;EACE,gBAAA;EACA,YAAA;EACA,yBAziBW;EA0iBX,WAthBY;EAuhBZ,eAAA;EACA,gBA5kBc;EA6kBd,YAAA;ACxDF;;AD2DA;EACE,oCAAA;EACA,sBAAA;EACA,2BAAA;ACxDF;;AD2DA;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;ACxDF;;AD2DA;;;EAGE,yBA/jBW;EAgkBX,WA5iBY;EA6iBZ,YAAA;ACxDF;;AD2DA;EACE,yBA/lBc;ACuiBhB;;AD2DA;;;EAGE,yBArmBc;AC6iBhB;;AD2DA;EACE,MAAA;ACxDF;;AD6DA;EACE,aAAA;EACA,kBAAA;AC1DF;;AD6DA;EACE,mBAAA;AC1DF;;AD6DA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AC1DF;;AD6DA;EACE,UAAA;AC1DF;;AD6DA;EACE,yCAnmBc;EAomBd,cAxmBkB;AC8iBpB;;AD6DA;EACE,aA5mBkB;ACkjBpB;;AD6DA;EACE,yBAxmBgB;AC8iBlB;;AD6DA;EACE,yBAAA;AC1DF;;AD6DA;EACE,6BAAA;EACA,yBAAA;EACA,WAvmBY;AC6iBd;;AD6DA;;EAEE,yBA7nBkB;EA8nBlB,WA7mBY;ACmjBd;;AD4DA;EACE,6BAAA;EACA,yBAAA;EACA,WAlnBY;ACyjBd;;AD4DA;EACE,yBA/nBsB;EAgoBtB,WAvnBY;AC8jBd;;AD4DA;;;EAGE,WA7nBY;ACokBd;;AD4DA;;EAEE,yBA7oBgB;EA8oBhB,WAnoBY;AC0kBd;;AD4DA;EACE,yBAtrBO;AC6nBT;;AD4DA;EACE,eAtpBgB;AC6lBlB;;AD4DA;EACE,YA/oBY;ACslBd;;AD4DA;;EAEE,sBAAA;ACzDF;;AD4DA,iBAAA;AAUA;EACE;IACE,gBAAA;EClEF;AACF;ADoEA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;EClEF;EDoEA;IACE,2BAAA;IACA,gBAAA;EClEF;AACF;ADoEA;EACC;;KAAA;AChED;ADoEA;EACE;IACE,uBAAA;EClEF;EDoEA;IACE,6BAAA;EClEF;AACF;ADoEA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,wBAAA;EClEF;EDoEA;IACE,kBAAA;EClEF;AACF;ADqEA;EACE;IACI,iBAAA;ECnEJ;EDqEA;IACI,gBAAA;ECnEJ;AACF;AA3sBA;EACI,mBAAA;EACA,oBAAA;AA6sBJ;AA3sBI;EACI,eAAA;AA6sBR;AA3sBI;EACI,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,kBAAA;AA6sBR;AA1sBI;EACI,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,kBAAA;EACA,WD2CM;EC1CN,yBDuDW;ACqpBnB;AAxsBI;EACI,WDqCM;ECpCN,yBDiDW;ACypBnB;AAvsBI;EACI,WDgCM;EC/BN,yBD4CW;AC6pBnB;AAtsBM;EACE,kBAAA;AAwsBR;;AAnsBY;EACI,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;AAssBhB;AArsBgB;EACI,eAAA;EACA,iBAAA;AAusBpB;AArsBgB;EACI,kBAAA;AAusBpB;AArsBgB;EACI,WAAA;EACA,YAAA;EACA,kBAAA;AAusBpB;AArsBgB;EACI,iBAAA;AAusBpB;AApsBgB;EACI,qBAAA;EACA,iBAAA;AAssBpB;AAnsBgB;EACI,eAAA;EACA,gBAAA;AAqsBpB;AAnsBgB;EACI,eAAA;EAEA,qBAAA;EACA,WDZN;ECaM,yBAAA;EACA,aAAA;EACA,kBAAA;AAosBpB;AAjsBgB;EACI,YAAA;AAmsBpB;AA/rBoB;EACI,yBAAA;EACA,mBAAA;EACA,kBAAA;AAisBxB;AA/rBwB;EACI,eAAA;EACA,gBDlFZ;ECmFY,cD3EX;EC4EW,kBAAA;EACA,cAAA;AAisB5B;AA9rB4B;EACI,cDnFhB;ACmxBhB;AA7rBwB;EACI,eAAA;EACA,gBD9FZ;EC+FY,WD3Cd;EC4Cc,mBAAA;EACA,sBAAA;AA+rB5B;;AA1rBA;EACI,6BAAA;AA6rBJ;;AA1rBA;EACI,yBDxEgB;ECyEhB,WDxDU;ACqvBd;;AA1rBA;EACI,yBD1GY;EC2GZ,WD7DU;AC0vBd;;AA1rBA;EACI,sBAAA;AA6rBJ;;AAvqBC;EACG;IACG,sBAAA;EA0qBL;AACF;AAvqBA;EACI;IACI,wBAAA;EAyqBN;EAvqBI;IACE,4BAAA;IACA,0BAAA;EAyqBN;EAvqBE;IACI,4BAAA;IACA,0BAAA;EAyqBN;EAvqBE;IACI,mBAAA;EAyqBN;AACF;AAtqBA;EACM;IACE,4BAAA;IACA,0BAAA;EAwqBN;EAtqBE;IACI,4BAAA;IACA,0BAAA;EAwqBN;AACF;AArqBA;EACI;IACE,4BAAA;IACA,0BAAA;EAuqBJ;EArqBA;IACI,4BAAA;IACA,0BAAA;EAuqBJ;AACF;AAnqBA;EACE;IACE,wBAAA;EAqqBF;EAnqBA;IACE,2BAAA;EAqqBF;AACF;AA9pBA;EACI;IACI,wBDtHI;ICuHJ,UDtHG;ICuHH,kBAAA;IACA,aD9HW;EC8xBjB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap');\n\nbody {\n  font-family: \"Urbanist\", sans-serif !important;\n}\n\n/* \nscss\n */\n$font-regular: 400;\n$font-medium: 500;\n$font-semiBold: 600;\n$font-bold: 700;\n$font-extraBold: 800;\n$font-black: 900;\n\n$mainBg: #F5F6FA;\n$primary-color: #131F43;\n$icon-bgcolor: #F6F6F6;\n$text-graycolor: #727272;\n$cardIcon1-bg: #DBEAFE;  \n$cardIcon1-darkbg: #30231a;\n$cardIcon1-darkbg-icon: #9d785f;\n$cardIcon2-bg: #D1FAE5;  \n$cardIcon2-darkbg: #13252a;\n$cardIcon2-darkbg-icon: #3b606a;\n$cardIcon3-bg: #FEF3C7;  \n$cardIcon3-darkbg: #2c1a27;\n$cardIcon3-darkbg-icon: #6c4863;\n$cardIcon4-bg: #E9D5FF; \n$cardIcon4-darkbg: #241d3e;\n$cardIcon4-darkbg-icon: #5f538b;\n$cardIcon1-color: #3B82F6;  \n$cardIcon2-color: #10B981;  \n$cardIcon3-color: #F59E0B;  \n$cardIcon4-color: #8B5CF6;  \n$green-color: #38A169;\n$darkGreen-color: #207a4a;\n$placeholder-color: #666666;\n$profile-dark-text: #181818;\n$heading : #0B0D0F;\n$light-gray : #999999;\n$menu_icon : #CBCBCB;\n$red-color : #F94747;\n$dark-active-blue : #3b82f6;\n$dark-light-blue : #92afd3;\n$addBtn-dark-blue : #3b82f6;\n$addBtn-dark-blue-hover : #2563eb;\n$backBtn-dark : #3b82f633;\n\n\n\n$darkTheme_blue : #132337;\n$darkTheme_darkBlue : #0f1824;\n$darkTheme_selectBlue : #1c2e45;\n$darkTheme_updateBtn : #0a2574;\n\n/* \nBody Theme Color\n */\n$lightthemecolor: #f3f6f9;\n$darkthemecolor: #151521;\n\n$white-color: #fff;\n$black-color: #1d1d1d;\n$fullBlack-color: #1d1d1d;\n$lightthemetext: #60677e;\n\n/* \nDark Theme Colors\n*/\n$primarydark-color: #132337;\n\n/* \nButton Theme\n*/\n$primary-btncolor: #131F43;\n$secondary-btncolor: rgba(37, 105, 109, 0.864);\n\n$tableheadlightbg: #e9eaf0;\n\n\n/* \nMax Dashboard scss\n*/\n$dashboardwidth: calc(100% - 320px);\n$dashboardposition: absolute;\n$dashboardleft: 290px;\n$dashboardpadding: 30px;\n\n/* \nMin Dashboard scss\n*/\n$dashwidth: calc(100% - 50px);\n$dashleft: 50px;\n\n/* \nMax Dashboard scss\n*/\n\n.dashboard {\n  width: $dashboardwidth;\n  position: relative;\n  left: $dashboardleft;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  min-height: auto !important;\n  background-color: $mainBg;\n  height: calc(100vh - 160px);\n  overflow-y: auto;\n}\n.dashboardContain { \n  width: calc(100% - 320px);\n  background-Color:$mainBg;\n  border-radius: 8px;\n}\n.bodythemedark .dashboardContain,\n.bodythemedark .dashboard, \n.bodythemedark .cont2 { \n  background-Color: $darkTheme_darkBlue;\n}\n.top_header .top_header_inner {\n  background-color: transparent;\n  height: auto;\n  overflow-y: unset;\n}\n\n/* \nMin Dashboard scss\n*/\n\n.cont2 {\n  width: $dashwidth;\n  left: $dashleft;\n  position: relative;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  background: $mainBg;\n  height: calc(100vh - 160px);\n  min-height: auto !important;\n  overflow-y: auto;\n  /* \nbackground-Color: $dashboardbackgroundColor;\n  padding-bottom: 8%;\n*/\n}\n\n.subLink svg {\n  position: relative;\n  top: -2px;\n  left: -7px;\n}\n\n\n\n.footer {\n  height: 70px;\n}\n\nbody {\n  background-color: $white-color;\n}\n\n/* \nTHEME CHANGE\n*/\n.bodythemelight {\n  background-color: $white-color;\n  padding-top: 90px;\n}\n.bodythemedark {\n  background-color: $darkTheme_blue;\n  padding-top: 90px;\n}\n\n/* \nHeader Navbar Theme\n*/\n.headerthemelight {\n  background-color: $white-color;\n}\n\n.headerthemedark {\n  background-color: $darkTheme_blue;\n}\n.top_header {\n  min-height: 90px;\n  display: flex;\n  align-items: center;\n  position: fixed;\n  width: 100%;\n  z-index: 1; \n  top: 0;\n}\n\n/* \nLEFT MENU THEME CHANGE\n*/\n.menuthemelight {\n  background-color: $white-color;\n}\n.menuthemedark {\n  background-color: $darkTheme_blue;\n}\n\n/* \nLEFT MENU LINKS THEME CHANGE\n*/\n.menulinklight span {\n  color: $placeholder-color !important;\n}\n\n.menulinklight a {\n  color: $menu_icon !important;\n}\n\n.menulinklight:hover span, .menulinklight:hover a { \n  color: $white-color !important;\n}\n\n.menulinkdarkSelected {\n  background-color: $darkTheme_selectBlue;\n  color: $dark-active-blue;\n}\n.menuthemelight .menulinklightSelected {\n  /*background-color: $lightthemecolor;*/\n  color: $white-color !important;\n  background-color: $primary-color;\n}\n\n.menulinkdark {\n  color: $dark-light-blue !important;\n}\n\n.menulinklight:hover {\n  color: $white-color !important;\n  background-color: $primary-color;\n}\n\n.menulinklight .sub_arrow svg path{\n  stroke: $menu_icon !important;\n}\n\n.menulinklight:hover .sub_arrow svg path{\n  stroke: $white-color !important;\n}\n\n.menulinkdark .sub_arrow svg path{\n  stroke: $dark-light-blue !important;\n}\n\n.menulinkdark:hover .sub_arrow svg path{\n  stroke: $white-color !important;\n}\n\n.menulinkdark:hover {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n/* \nBODY HEADERS\n*/\n.headinglight {\n  color: $lightthemetext;\n}\n\n.headingdark {\n  color: $lightthemetext;\n}\n\n/* \nSEARCH BOX THEME COLOR\n*/\n.searchboxlight {\n  background-color: $white-color;\n  border: none;\n}\n\n.searchboxdark {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n  border: none;\n}\n.searchboxdark::placeholder {\n  color: $lightthemetext;\n}\n\n/* \nCUSTOM TABLE THEME COLOR\n*/\n.tableheadlight {\n  background-color: $primary-color;\n  border-radius: 5px 5px 0px 0px;\n}\n.tableheadlight th {\n  color: $white-color;\n}\nthead .tableheadlight th:first-child,\nthead .tableheaddark th:first-child {\n  border-radius: 5px 0 0 0px;\n} \nthead .tableheadlight th:last-child,\nthead .tableheaddark th:last-child  {\n  border-radius: 0 5px 0px 0;\n}\nth:first-child {\n  border-radius: 0px;\n} \ntd:last-child {\n  border-radius: 0px;\n}\ntable.table.table-borderless{\n  border-collapse: separate !important;\n  border-spacing: 0 0px !important;\n}\n\n.tableheaddark {\n  background-color: $primarydark-color;\n  color: $white-color;\n}\n.table-borderless tr:nth-child(even) {\n  background-color: #F9FAFB;\n}\n.table-borderless .left-section {\n  padding-top: 10px;\n}\n.tablebodylight td, \n.tablebodydark td {\n  padding: 0.5rem 1rem !important;\n  line-height: 45px;\n}\n.tablebodylight {\n  background-color: $white-color;\n\n  &:hover {\n    background-color: #ddecf9;\n    cursor: auto;\n  }\n}\n.tablebodydark {\n /* background-color: $primarydark-color; */\n  color: $lightthemetext;\n\n  &:hover {\n    background-color: rgba(33, 150, 243, 0.1);\n    cursor: auto;\n  }\n}\n\n/* \nPAGINATION THEME COLOR\n*/\n.paginationlight {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n.paginationdark {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n/* \nSETTING FORM THEME COLOR\n*/\n.formthemelight {\n  background-color: $white-color;\n  color: $black-color !important;\n  box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);\n}\n.formthemedark {\n  background-color: $primarydark-color;\n  color: $lightthemetext !important;\n  font-size: 14px;\n\n  ::placeholder {\n    color: $lightthemetext;\n  }\n}\n\n\n/* \nVIEW FORM DETAILS BOX THEME COLOR\n*/\n.viewformlight {\n  background-color: $lightthemecolor;\n}\n\n.permissionboxlight {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n}\n.permissionboxdark {\n  background-color: $darkTheme_darkBlue;\n  border: solid 1px #242434;\n}\n\n.errormsgclr {\n  color: red;\n  font-size: 14px;\n  margin-top: 5px;\n}\n\n/* \nGraph theme\n*/\n.graphclrlight {\n  background-color: $white-color;\n}\n\n.graphclrdark {\n  background-color: $primarydark-color;\n}\n\n\n/* \nCounter theme\n*/\n#card1bglight {\n  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card1bgdark {\n  background: #392f28;\n}\n\n#card2bglight {\n  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card2bgdark {\n  background: #1c3238;\n}\n\n#card3bglight {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card3bgdark {\n  background: #3a2434;\n}\n\n#card4bglight {\n  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card4bgdark {\n  background: #2f264f;\n}\n\n#card1bgdark a, #card1bgdark p,\n#card2bgdark a , #card2bgdark p,\n#card3bgdark a, #card3bgdark p,\n#card4bgdark a, #card4bgdark p {\n  color: $white-color;\n}\n\n/* \nAction button theme\n*/\n.actionbtnlight {\n  color: #46475bde;\n}\n.actionbtnlight:hover{\n  cursor: pointer;\n}\n.actionbtndark {\n  color: $lightthemetext;\n}\n\n\n/* \nprofile dropdowntheme\n*/\n.profiledropdownlight {\n  background-color: #fff;\n}\n\n.profiledropdowndark {\n  background-color: #151521;\n}\n\n.settingsection #addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n#addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.profile_conatiner {\n  border-radius: 5px !important; \n}\n\n.bodythemedark .ag-theme-alpine .ag-row {\n  background: #000 !important;\n}\n\n.bodythemedark .formbtn {\n  background-color: $addBtn-dark-blue;\n}\n\n.bodythemedark .formbtn:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.bodythemedark .resetbtn {\n  color: $white-color;\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n}\n\n.bodythemedark .resetbtn:hover {\n  background-color: $addBtn-dark-blue;\n}\n\n\n.headingdark span {\n  background-color: $darkTheme_blue;\n}\n\n.resetbtn {\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border-radius: 5px;\n  background-color: transparent;\n  border: solid 1px $primary-color;\n  color:  $primary-color;\n  min-width: 113px;\n}\n.resetbtn:hover, \n.resetbtn:active, \n.resetbtn:focus {\n  background-color: $primary-color;\n  color: $white-color;\n}\n\n.addBtn {\n  min-width: 140px;\n  height: 44px;\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n}\n\n.addbtnlight {\n  background-color: $green-color;\n}\n.addbtndark {\n  background-color: $addBtn-dark-blue;\n}\n.addbtndark:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.formthemedark label {\n  color: $dark-light-blue;\n}\n\n\n.addBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: 2px;\n}\n\n.addBtn:hover {\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n}\n\n.cust_addBtn.addBtn svg {\n  top: 2px;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn:active, .deleteBtn:focus {\n  background-color: $red-color !important;\n  color: $white-color !important; \n  box-shadow: none !important;\n}\n\n.deleteBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: -2px;\n}\n\n.deleteBtn:hover, \n.deleteBtn:active, \n.deleteBtn:focus {\n  background-color: $red-color;\n  color: $white-color;\n  border: none;\n}\n\n.confirmBtn {\n  background-color: $primary-color;\n}\n\n.confirmBtn:hover, \n.confirmBtn:active, \n.confirmBtn:focus {\n  background-color: $primary-color;\n}\n\n.confirmBtn svg {\n  top: 0;\n}\n\n\n\n.delPopContainer .modal-body {\n  padding: 25px;\n  text-align: center;\n}\n\n.delPopContainer .delet_icon {\n  margin-bottom: 11px;\n}\n\n.delPopContainer p {\n  color: #131f43;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.arrowback svg{\n  fill: #000; \n}\n\n.bodythemedark .arrowback {\n  background-color: $backBtn-dark; \n  color: $dark-active-blue;\n}\n\n.bodythemedark .arrowback svg {\n  fill: $dark-active-blue;\n}\n\n.bodythemedark .drpdwn_btn {\n  background-color: $darkTheme_blue;\n}\n\n.bodythemedark .empname {\n  color: $dark-light-blue !important;\n}\n\n.bodythemedark .navitemli a {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.bodythemedark .tabnavli a.settingsgeneral, \n.bodythemedark .tabnavli a.settingslinks:hover {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n.bodythemedark .tabnavli a.settingslinks {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a,\n.headerthemedark .dropdown_menu_contain .dropdown_item, \n.headerthemedark .dropdown_menu_contain .dropdown_item h5 {\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a:hover,\n.headerthemedark .dropdown_menu_contain .dropdown_item:hover {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n}\n\n.dropdown_item:active {\n  background-color: $mainBg;\n}\n\n.profile_arrrow_dwn {\n  stroke: $darkTheme_blue;\n}\n\n.headerthemedark .profile_arrrow_dwn {\n  stroke: $white-color;\n}\n\n.dateinputbox1 input, \n.dateinputbox1 span {\n  color: $white-color !important;\n}\n\n/* LOGOUT MODAL */\n.modalStyleLight {\n\n}\n\n.modalStyleDark {\n  \n}\n\n\n@media only screen and (max-width: 1200px) {\n  .tableheadlight th {\n    min-width: 100px;\n  }\n}\n@media only screen and (max-width: 1024px) { \n  .dashboard {\n    width: calc(100% - 50px) !important;\n    left: 50px !important;\n    padding: 10px 10px !important;\n  }\n  .cont2 {\n    height: calc(100vh - 160px);\n    overflow-y: auto;\n  }\n}\n@media only screen and (max-width: 998px) { \n /* #dashboardcont2{\n    height: auto !important;\n  }*/\n}\n@media only screen and (max-width: 767px) { \n  .sectionright{\n    float: unset !important;\n  }\n  .dashboard {\n    padding: 10px 10px !important;\n  }\n}\n@media only screen and (max-width: 600px) {\n  .cont2 {\n    width: $dashwidth !important;\n    left: $dashleft !important;\n    position: relative !important;\n    padding: 10px !important;\n  }\n  .bodythemelight, .bodythemedark {\n    padding-top: 110px;\n  }\n}\n\n@media (min-width: 576px) {\n  .exer_modal_contain .modal-dialog {\n      max-width: 1055px;\n  }\n  .delPopContainer .modal-dialog {\n      max-width: 350px;\n  }\n}","@import \"../../styles/Variables/Variables.scss\";\n.settingsection{\n    margin-bottom: 50px;\n    padding-bottom:30px;\n\n    #settingsheading{\n        font-size: 18px;\n    }\n    .settingslinks{\n        text-decoration: none;\n        letter-spacing: 0.15em;\n        display: inline-block;\n        position: relative; \n    }\n\n    .settingsgeneral{\n        text-decoration: none;\n        letter-spacing: 0.15em;\n        display: inline-block;\n        position: relative; \n        color: $white-color;\n        background-color: $primary-btncolor;\n    }\n\n    \n    .settingslinks:hover{\n        color: $white-color;\n        background-color: $primary-btncolor;\n    }\n    \n    .settingsgeneral:hover{\n        color: $white-color;\n        background-color: $primary-btncolor;\n      }\n\n      #layoutnav{\n        border-radius: 5px;\n      }\n\n}\n                \n            #addform{\n                width: 100%;\n                border-radius: 5px;\n                margin-top: 30px;\n                padding-bottom:30px;\n                #addheading{\n                    font-size: 18px;\n                    margin-left: 10px;\n                }\n                .profilepicdiv{\n                    border-radius: 5px;\n                }\n                .profilepic{\n                    width: 100%;\n                    height: auto;\n                    border-radius: 5px;\n                }\n                .penicon{\n                    margin-right: 5px;\n                }\n\n                .namesection{\n                    display: inline-block;\n                    margin-left: 20px;\n                }\n\n                .profilename{\n                    font-size: 16px;\n                    margin-top: 30px;\n                }\n                .profileedit{\n                    font-size: 14px;\n                     \n                    text-decoration: none;\n                    color: $white-color;\n                    background-color: $primary-btncolor;\n                    padding: 10px;\n                    border-radius: 4px;\n                }\n            \n                .editbtntop{\n                    float: right;\n                }\n\n\n                    #empdiv{\n                        padding:0px 0px 0px 15px;\n                        margin-bottom: 10px;\n                        border-radius: 5px;\n\n                        .title{\n                            font-size: 13px;\n                            font-weight: $font-semiBold;\n                            color: $text-graycolor;\n                            margin-bottom: 7px;\n                            display: block;\n                        }\n                        &.viewformlight {\n                            .empname{\n                                color: $primary-color;\n                            }\n                        }\n                        .empname{\n                            font-size: 16px;\n                            font-weight: $font-semiBold;\n                            color: $white-color;\n                            padding-bottom:0px;\n                            word-break: break-word;\n                        }\n                    }\n            }\n\n.viewformlight {\n    background-color: transparent;\n}\n\n.bodythemedark #addform.formthemedark .profileedit {\n    background-color: $addBtn-dark-blue;\n    color: $white-color;\n}\n\n.bodythemelight #addform.formthemelight .profileedit {\n    background-color: $primary-color;\n    color: $white-color;\n}\n\n.formthemedark #empdiv .title {\n    color: $white-color !important;\n}\n  \n\n// @media only screen and (max-width: 1324px) {\n//     .editbtntop{\n//         margin-left: 40px !important;\n//     }\n//     }\n\n// @media only screen and (max-width: 1324px) {\n//     .editbtntop{\n//         margin-left: 20px !important;\n//     }\n// }\n\n// @media only screen and (max-width: 1200px) {\n//     .editbtntop{\n//         margin-left: 50px !important;\n//     }\n// }\n\n @media only screen and (max-width: 992px) {\n    .editbtntop{\n       float: left !important;\n    }\n}\n\n@media only screen and (max-width: 878px) {\n    #layoutnav{\n        display: flex !important;\n      }\n      .settingslinks{\n        margin-right: 8px !important;\n        font-size: 14px !important;\n    }\n    .settingsgeneral{\n        margin-right: 8px !important;\n        font-size: 14px !important;\n    }\n    #addform .profilepic{ \n        margin-bottom: 30px;\n    }\n}\n\n@media only screen and (max-width: 510px) {\n      .settingslinks{\n        margin-right: 6px !important;\n        font-size: 13px !important;\n    }\n    .settingsgeneral{\n        margin-right: 6px !important;\n        font-size: 13px !important;\n    }\n}\n\n@media only screen and (max-width: 495px) {\n    .settingslinks{\n      margin-right: 5px !important;\n      font-size: 12px !important;\n  }\n  .settingsgeneral{\n      margin-right: 5px !important;\n      font-size: 12px !important;\n  }\n}\n\n\n@media only screen and (max-width: 331px) {\n  .settingsgeneral,  .settingslinks{\n    padding: 12px !important;\n  }\n  .namesection{\n    margin-left: 5px !important;\n\n}\n}\n\n\n\n\n@media only screen and (max-width: 600px) {\n    #dashboardcont2{\n        width: $dashwidth;\n        left: $dashleft;\n        position: relative;\n        padding: $dashboardpadding;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `profilepage_dashboard__f7faf`,
	"dashboardContain": `profilepage_dashboardContain__hkddW`,
	"bodythemedark": `profilepage_bodythemedark__U3bK3`,
	"cont2": `profilepage_cont2__vX6Z8`,
	"top_header": `profilepage_top_header__ghfWd`,
	"top_header_inner": `profilepage_top_header_inner__tctlf`,
	"subLink": `profilepage_subLink__a0P7-`,
	"footer": `profilepage_footer__35p4i`,
	"bodythemelight": `profilepage_bodythemelight__yGXd9`,
	"headerthemelight": `profilepage_headerthemelight__HG24f`,
	"headerthemedark": `profilepage_headerthemedark__6lim7`,
	"menuthemelight": `profilepage_menuthemelight__RZgav`,
	"menuthemedark": `profilepage_menuthemedark__Wr+AP`,
	"menulinklight": `profilepage_menulinklight__ZWenu`,
	"menulinkdarkSelected": `profilepage_menulinkdarkSelected__ns9y7`,
	"menulinklightSelected": `profilepage_menulinklightSelected__bHyyK`,
	"menulinkdark": `profilepage_menulinkdark__33m+h`,
	"sub_arrow": `profilepage_sub_arrow__5Zuyi`,
	"headinglight": `profilepage_headinglight__+d+Kj`,
	"headingdark": `profilepage_headingdark__U9OsA`,
	"searchboxlight": `profilepage_searchboxlight__+vXmM`,
	"searchboxdark": `profilepage_searchboxdark__PlzjR`,
	"tableheadlight": `profilepage_tableheadlight__N+1m0`,
	"tableheaddark": `profilepage_tableheaddark__pzdGJ`,
	"table": `profilepage_table__PkPOM`,
	"table-borderless": `profilepage_table-borderless__3OWpu`,
	"left-section": `profilepage_left-section__yST00`,
	"tablebodylight": `profilepage_tablebodylight__G8aH6`,
	"tablebodydark": `profilepage_tablebodydark__aL83x`,
	"paginationlight": `profilepage_paginationlight__JC8Io`,
	"paginationdark": `profilepage_paginationdark__47-Us`,
	"formthemelight": `profilepage_formthemelight__x+moB`,
	"formthemedark": `profilepage_formthemedark__cHqTr`,
	"viewformlight": `profilepage_viewformlight__k+6pb`,
	"permissionboxlight": `profilepage_permissionboxlight__LHtZE`,
	"permissionboxdark": `profilepage_permissionboxdark__B-n-5`,
	"errormsgclr": `profilepage_errormsgclr__KHi1K`,
	"graphclrlight": `profilepage_graphclrlight__afP5N`,
	"graphclrdark": `profilepage_graphclrdark__q0mUw`,
	"card1bglight": `profilepage_card1bglight__TdFoy`,
	"card1bgdark": `profilepage_card1bgdark__LnXNf`,
	"card2bglight": `profilepage_card2bglight__fuVfR`,
	"card2bgdark": `profilepage_card2bgdark__aYkis`,
	"card3bglight": `profilepage_card3bglight__Aaxrz`,
	"card3bgdark": `profilepage_card3bgdark__Jk5Oj`,
	"card4bglight": `profilepage_card4bglight__Kgj-s`,
	"card4bgdark": `profilepage_card4bgdark__d9yP4`,
	"actionbtnlight": `profilepage_actionbtnlight__oe7Kr`,
	"actionbtndark": `profilepage_actionbtndark__D07fP`,
	"profiledropdownlight": `profilepage_profiledropdownlight__+l7Jy`,
	"profiledropdowndark": `profilepage_profiledropdowndark__2Nv11`,
	"settingsection": `profilepage_settingsection__GDOL5`,
	"addform": `profilepage_addform__DRU9M`,
	"savebtn": `profilepage_savebtn__pa-Rp`,
	"profile_conatiner": `profilepage_profile_conatiner__n+Sap`,
	"ag-theme-alpine": `profilepage_ag-theme-alpine__t+UOw`,
	"ag-row": `profilepage_ag-row__qd5R6`,
	"formbtn": `profilepage_formbtn__JcqVp`,
	"resetbtn": `profilepage_resetbtn__Qq1fD`,
	"addBtn": `profilepage_addBtn__lX2tJ`,
	"addbtnlight": `profilepage_addbtnlight__6xH2o`,
	"addbtndark": `profilepage_addbtndark__KT3sY`,
	"cust_addBtn": `profilepage_cust_addBtn__kVlDz`,
	"deleteBtn": `profilepage_deleteBtn__hnEUw`,
	"confirmBtn": `profilepage_confirmBtn__HkdQl`,
	"delPopContainer": `profilepage_delPopContainer__4yMmw`,
	"modal-body": `profilepage_modal-body__nGjkw`,
	"delet_icon": `profilepage_delet_icon__UqIhu`,
	"arrowback": `profilepage_arrowback__70GXL`,
	"drpdwn_btn": `profilepage_drpdwn_btn__o1f9m`,
	"empname": `profilepage_empname__qjhb9`,
	"navitemli": `profilepage_navitemli__SMmg1`,
	"tabnavli": `profilepage_tabnavli__3ewNE`,
	"settingsgeneral": `profilepage_settingsgeneral__rW4Tl`,
	"settingslinks": `profilepage_settingslinks__MsUdd`,
	"dropdown_menu_contain": `profilepage_dropdown_menu_contain__iir6-`,
	"dropdown_item": `profilepage_dropdown_item__CrmAQ`,
	"profile_arrrow_dwn": `profilepage_profile_arrrow_dwn__r+RYo`,
	"dateinputbox1": `profilepage_dateinputbox1__kTTaR`,
	"sectionright": `profilepage_sectionright__+Mbgv`,
	"exer_modal_contain": `profilepage_exer_modal_contain__oT7Kn`,
	"modal-dialog": `profilepage_modal-dialog__9G6zp`,
	"settingsheading": `profilepage_settingsheading__eY9X1`,
	"layoutnav": `profilepage_layoutnav__wq9JM`,
	"addheading": `profilepage_addheading__-dxn3`,
	"profilepicdiv": `profilepage_profilepicdiv__pd+Tp`,
	"profilepic": `profilepage_profilepic__LNywb`,
	"penicon": `profilepage_penicon__lFo6n`,
	"namesection": `profilepage_namesection__iSS9i`,
	"profilename": `profilepage_profilename__elZhR`,
	"profileedit": `profilepage_profileedit__GF2gr`,
	"editbtntop": `profilepage_editbtntop__vydyF`,
	"empdiv": `profilepage_empdiv__Q3gCu`,
	"title": `profilepage_title__edgfj`,
	"dashboardcont2": `profilepage_dashboardcont2__-ZZ-P`
};
export default ___CSS_LOADER_EXPORT___;
